const Alert = require('sma.admin/components/alert.js');
const Loader = require('sma.admin/components/loader');
const progressTempl = require('sma.admin/components/partials/progress.mustache');

const newProgressBar = function() {
  let xhr = new window.XMLHttpRequest();
  let startDate;
  let lastPercent = 0;
  let fakeIt = false;
  let grid = null;
  let tableWrap = this.progressData.tableWrap;

  var fadeOutProgress = $el => {
    if (grid) {
      grid.load();
    }

    setTimeout(() => {
      if (tableWrap) {
        $el.find('td').slideUp(500);
        $el.find('td > div').slideUp(500, () => $el.remove());
      } else {
        $el.slideUp(500, () => $el.remove());
      }
    }, 3000);
  };

  // execute this when progress bar is 100%
  var done = $el => {
    $el
      .find('.sma-js-progress-cancel')
      .replaceWith('<i class="nc-icon-mini ui-1_check-simple"></i>');
    fadeOutProgress($el);
  };

  // show progress state
  var displayProgress = (percentComplete, $el) => {
    $el.find('.sma-js-percentage').text(percentComplete);
    $el.find('.progress').val(percentComplete);
  };

  // do this to simulate loading if the file is uploaded to fast
  var doFakeProgress = $el => {
    var fakePercent = 0;
    var fakeProgInterval = setInterval(() => {
      displayProgress(fakePercent, $el);

      if (fakePercent >= 100) {
        clearInterval(fakeProgInterval);
        done($el);
      }

      fakePercent += 1;
    }, 10);
  };

  // do this when starting the upload
  xhr.upload.onloadstart = evt => {
    let data = this.progressData;
    data.$el =
      data.$el ||
      $(
        progressTempl({
          filename: data.filename,
          cancelText: gettext('Cancel'),
          tableWrap: data.tableWrap || false,
        })
      );

    grid = data.grid || null;

    data.$el.find('.sma-js-progress-cancel').click(function() {
      xhr.abort();
      data.$el.find('.sma-js-percentage-wrap').html('CANCELLED');
      fadeOutProgress(data.$el);

      new Alert({
        type: 'danger',
        message: gettext('File upload was cancelled.'),
      });
      return false;
    });

    if (data.prepend) {
      data.$el
        .prependTo(data.$container)
        .find('td')
        .hide();
    } else {
      data.$el
        .appendTo(data.$container)
        .find('td')
        .hide();
    }
    data.$el.find('td').slideDown(500);
    data.$el.find('td > div').slideDown(500);

    startDate = new Date();
  };

  // do this every 30 or so milliseconds while uploading
  xhr.upload.addEventListener(
    'progress',
    evt => {
      if (evt.lengthComputable) {
        var percentComplete = evt.loaded / evt.total;
        percentComplete = parseInt(percentComplete * 100);

        var timeDelta = new Date() - startDate;

        //tweak this value, it is the threshhold to determine if we will fake progress
        if (percentComplete - lastPercent > 10 && !fakeIt) {
          fakeIt = true;
        }

        // only display during progress if were not going to fake it
        if (!fakeIt) {
          displayProgress(percentComplete, this.progressData.$el);
        }

        // either fake the progress or finish up once completed
        if (percentComplete === 100) {
          if (fakeIt) {
            doFakeProgress(this.progressData.$el);
            percentComplete = 0;
          } else {
            done(this.progressData.$el);
          }
        }

        lastPercent = percentComplete;
      }
    },
    false
  );

  return xhr;
};

const REQUEST = (options) => {
	if (options.loaderElement !== undefined) {
		options.loaderSize = options.loaderSize || 'md';
		options.loader = new Loader(options.loaderElement, options.loaderSize);
		options.loader.show();
	}

	const alertOnSuccess = 'alertOnSuccess' in options ? options.alertOnSuccess : true;
	const defaultSuccessAlert = 'defaultSuccessAlert' in options ? options.defaultSuccessAlert : '';
	const alertOnError = 'alertOnError' in options ? options.alertOnError : true;
	const noMultiple = 'noMultiple' in options ? options.noMultiple : false;
	const onFail = options.onFail || options.error || function() {};

	let contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
	let data = 'data' in options ? options['data'] : {};

	// default datatype will be json and will set contentType to javascript
	// unless contentType is passed in
	if (options.type === 'POST' &&
		(options.dataType === undefined || options.dataType === 'json') &&
		!('contentType' in options)) {

		contentType = 'application/json; charset=UTF-8';
		data = JSON.stringify(data);
	}

	const ajaxOptions = {
		url: 'url' in options ? options['url'] : '',
		type: 'type' in options ? options['type'] : 'POST',
		data,
		async: 'async' in options ? options['async'] : true,
		processData: 'processData' in options ? options['processData'] : true,
		contentType:
			'contentType' in options ? options['contentType'] : contentType,
		dataType: 'dataType' in options ? options['dataType'] : 'json',
		progressData: options.progressData || null,
		headers: options.headers || null,
		success: (response, textStatus, jqXHR) => {
			let type;
			if (jqXHR.status === 204) {
				type = 'success';
			} else {
				if (response.success === false) {
					type = 'danger';
				} else {
					type = 'success';
				}
			}

			if (type === 'success' || 'alwaysCallback' in options) {
				const callback = 'callback' in options ? options['callback'] : function(_response) {};
				callback(response);
			}

			if ((alertOnSuccess && type === 'success')
				|| (alertOnError && type === 'danger')) {
				let oldAlerts = [];
				if (noMultiple) {
					oldAlerts = document.getElementsByClassName('alert-' + type);
				}
				if (!options.noAlert
					&& oldAlerts.length === 0
					&& !(options.noSuccessAlert && type === 'success')) {
					new Alert({
						type,
						message: response && response.message ? response.message : defaultSuccessAlert,
					});
				}
			}

			if (options.loader) {
				options.loader.hide();
			}
		},
	};

	if (options.progressBar) {
		ajaxOptions.xhr = newProgressBar;
	}

	$.ajax(ajaxOptions).fail((xhr, _textStatus, _errorThrown) => {
		onFail(xhr);
		if (alertOnError) {
			if (xhr.status === 409) {
				new Alert({
					type: 'warning',
					message: xhr.responseJSON.detail
				});
			} else if (xhr.status === 400 && xhr.responseJSON.non_field_errors) {
				new Alert({
					type: 'danger',
					message: xhr.responseJSON.non_field_errors[0]
				});
			} else {
				new Alert({
					type: 'danger',
					message: gettext('Unknown Error')
				});
			}
		}
	});
};

const POST = function(options) {
	options['type'] = 'POST';
	REQUEST(options);
};

const PUT = function(options) {
	options['type'] = 'PUT';
	REQUEST(options);
};

const DELETE = function(options) {
	options['type'] = 'DELETE';
	REQUEST(options);
};

const GET = function(options) {
	options['type'] = 'GET';
	options['noAlert'] = true;
	REQUEST(options);
};

$(function() {
  $('a.sma-ajax-post')
    .unbind('click')
    .click(e => {
      e.preventDefault();
      let $el = $(e.target);
      let url = $el.attr('href');
      
      
      POST({
        url: url,
        data: {},
        callback: (response) => {
          if (response.success && response.shouldRefresh) {
            // Refresh the page after successful AJAX request
            window.location.reload();
          }
        }
      });
      return true;
    });
});

module.exports = {
	request: REQUEST,
	post: POST,
	delete: DELETE,
	get: GET,
	put: PUT,
};

// options = {
// 	'url': SOMETHING_URL,
// 	'request_type': 'POST',
// 	'data': {
// 		'something': 1
// 	},
// 	'callback': (data) => {
// 		stuff(data)
// 	}
// }
